<script>
import { BFormSelectOption } from "bootstrap-vue";

export default {
  extends: BFormSelectOption
};
</script>